"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const Input = ({ value, onChange, onFocus, onBlur, id, error, placeholder, maxLength, disabled, type = 'text', className, name, }) => {
    return (react_1.default.createElement("input", { id: id, type: type, className: (0, classnames_1.default)('rounded border px-2 py-2 focus:outline-none focus:ring focus:ring-blue-4/40', error ? 'border-red-5' : 'border-grey-3 focus:border-blue-4', className), value: value, onChange: (e) => onChange(e.currentTarget.value, e), placeholder: placeholder, maxLength: maxLength, disabled: disabled, onFocus: onFocus, onBlur: onBlur, name: name }));
};
exports.Input = Input;
